import { DefaultCachingNumberFormatter as NumberFormatter } from '@square/dashboard-translations/utils/field-kit/default-caching-number-formatter';
export default class DefaultCurrencyCentFormatter extends NumberFormatter {
  constructor() {
    super();
    this.setNumberStyle(NumberFormatter.Style.CURRENCY).setMaximumFractionDigits(0).setMinimumFractionDigits(0).setPositivePrefix('').setPositiveSuffix('¢').setNegativePrefix('-').setNegativeSuffix('¢');
  }
}